import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { PageHeader, Card, Btn, Badge } from "@/components/UI";
import { ArrowLeft, Pencil } from "lucide-react";
import { ProductFormModal } from "@/components/products/ProductFormModal";
import { ProductImages } from "@/components/products/ProductImages";
import { ProductDocuments } from "@/components/products/ProductDocuments";
import { ProductPricing } from "@/components/products/ProductPricing";
import { ProductMaterials } from "@/components/products/ProductMaterials";
import { fmtQty } from "@/lib/products";
import { useProductCapabilities } from "@/lib/useProductCapabilities";

export default function ProductDetailPage() {
  const { id } = useParams();
  const nav = useNavigate();
  const [p, setP] = useState(null);
  const [error, setError] = useState("");
  const [edit, setEdit] = useState(false);
  const caps = useProductCapabilities();
  const load = () => api.get(`/products/${id}`).then(setP).catch(() => setError("Ürün bulunamadı"));
  useEffect(() => { load(); }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) return <div className="p-6 text-rose-600" data-testid="prod-detail-error">{error}</div>;
  if (!p) return <div className="p-6 text-slate-500">Yükleniyor…</div>;
  return (
    <div data-testid="product-detail-page">
      <PageHeader title={p.name} description={<span className="font-mono text-xs" data-testid="prod-detail-code">{p.code}</span>}
        actions={<div className="flex gap-2">
          <Btn variant="secondary" onClick={() => nav("/products")} data-testid="prod-detail-back"><ArrowLeft size={14} /> Listeye Dön</Btn>
          {caps.product_edit && <Btn onClick={() => setEdit(true)} data-testid="prod-detail-edit"><Pencil size={14} /> Düzenle</Btn>}
        </div>} />
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        <div className="lg:col-span-2 space-y-4">
          <Card className="p-5">
            <div className="flex items-center gap-2 mb-3">
              <Badge level={p.active ? "ok" : "inactive"}>{p.active ? "Aktif" : "Pasif"}</Badge>
            </div>
            <div className="text-[10px] uppercase tracking-wider text-slate-500 mb-0.5">Açıklama / Özellik</div>
            <div className="text-sm whitespace-pre-line" data-testid="prod-detail-description">{p.description || "—"}</div>
          </Card>
          <ProductMaterials productId={p.id} canEdit={caps.product_edit} />
          <ProductImages product={p} onChange={load} canEdit={caps.product_edit} />
          <ProductDocuments productId={p.id} canEdit={caps.product_edit} />
        </div>
        <div className="space-y-4">
          <ProductPricing product={p} />
          <Card className="p-5" data-testid="prod-detail-stock">
            <div className="text-sm font-semibold text-slate-700 mb-2">Stok</div>
            <div className="flex justify-between text-sm"><span>Mevcut Stok</span><b data-testid="prod-detail-stock-qty">{fmtQty(p.stock_qty)}</b></div>
            <div className="flex justify-between text-sm"><span>Kritik Stok Seviyesi</span><b data-testid="prod-detail-critical">{fmtQty(p.critical_stock)}</b></div>
            <Btn size="sm" variant="secondary" className="mt-3" onClick={() => nav("/stock")} data-testid="prod-detail-go-stock">Stok ekranına git</Btn>
          </Card>
        </div>
      </div>
      <ProductFormModal open={edit} product={p} onClose={() => setEdit(false)} onSaved={(s) => { setP(s); setEdit(false); }} />
    </div>
  );
}
